require('./polyfill');

var tool = require('./tool');
var dataService = require('./dataService');
var defaultUploadAws = require('./uploadAws');
var multipartUploadAws = require('./aws/multipartUploadAws');
var uploadCos = require('./cos/index');
var logger = require('./logger');

var AwsPartialUploader = require('./partial/uploadAwsPartial');
var CosPartialUploader = require('./partial/uploadCosPartial');

function getType(bucketInfoAndCredentialInfo) {
    if (
        !bucketInfoAndCredentialInfo ||
        !bucketInfoAndCredentialInfo.bucket_info ||
        !bucketInfoAndCredentialInfo.bucket_info.os_type
    ) {
        return false;
    }
    return bucketInfoAndCredentialInfo.bucket_info.os_type.toLocaleLowerCase();
}

function isAws(bucketInfoAndCredentialInfo) {
    return getType(bucketInfoAndCredentialInfo) === 'aws';
}

/**
 * 这个是cos兜底方案，如果umuos返回bos，需要按照bos的处理
 * @param {*} file
 * @param {*} uploadOptions
 */
function handleCos(file, uploadOptions) {
    uploadCos.getBucketInfoAndCredentialInfo(file, uploadOptions).then(
        function (result) {
            if (!result || result.error_code != 0 || !result.data) {
                logger.error('[umu-upload cos] handleCos getBucketInfoAndCredentialInfo result is null:', result);
                uploadOptions.error && uploadOptions.error();
                return;
            }
            var bucketInfoAndCredentialInfo = result.data || {};
            if (isAws(bucketInfoAndCredentialInfo)) {
                // 根据是否启用断点续传来选择上传方式
                uploadAws(file, uploadOptions);
            } else {
                uploadCos.upload(file, uploadOptions, bucketInfoAndCredentialInfo);
            }
        },
        function (err, data) {
            logger.error('[umu-upload cos] handleCos error:', err, file && file.name, data);
            uploadOptions.error && uploadOptions.error();
        }
    );
}

/**
 * 兼容处理
 * @param {*} providerName 供应商名称，bos，cos，aws
 */
function uploadByProvider(file, uploadOptions, providerName) {
    switch (providerName) {
        case 'cos':
            return handleCos(file, uploadOptions);
        case 'aws':
            return uploadAws(file, uploadOptions);
        default:
            break;
    }
}

function handleCosPartialUpload(file, uploadOptions) {
    return uploadCos.getBucketInfoAndCredentialInfo(file, uploadOptions).then(
        function (result) {
            if (!result || result.error_code != 0 || !result.data) {
                logger.error('[umu-upload cos] handleCosPartialUpload result is null:', result);
                uploadOptions.error && uploadOptions.error();
                return;
            }
            var bucketInfoAndCredentialInfo = result.data || {};
            if (isAws(bucketInfoAndCredentialInfo)) {
                return AwsPartialUploader;
            } else {
                return CosPartialUploader;
            }
        },
        function (err, data) {
            logger.error('[umu-upload cos] handleCosPartialUpload error:', err, data);
            uploadOptions.error && uploadOptions.error();
        }
    );
}

/**
 * 兼容处理
 * @param {*} providerName 供应商名称，bos，cos，aws
 */
function partialUploadByProvider(file, uploadOptions, callback, providerName) {
    switch (providerName) {
        case 'cos':
            return new Promise(function (resolve) {
                handleCosPartialUpload(file, uploadOptions).then(function (uploaderClassObj) {
                    resolve(new uploaderClassObj(file, uploadOptions, callback));
                });
            });
        case 'aws':
            return Promise.resolve(new AwsPartialUploader(file, uploadOptions, callback));
        default:
            console.error('[umu-upload] partialUploadByProvider Partial uploader not support provider ' + providerName);
            break;
    }
}

function cancelUpload(uploadId, providerName, isMultipart = false) {
    if (!providerName) {
        return false;
    }
    switch (providerName) {
        case 'cos':
            return uploadCos.cancelUpload(uploadId);
        case 'aws':
            if (isMultipart) {
                return multipartUploadAws.cancelUpload(uploadId);
            } else {
                return defaultUploadAws.cancelUpload(uploadId);
            }
        default:
            return false;
    }
}

function getUploadTasks(providerName, includeMultipart = false) {
    if (!providerName) {
        return [];
    }
    switch (providerName) {
        case 'cos':
            return uploadCos.getUploadTasks();
        case 'aws':
            var tasks = defaultUploadAws.getUploadTasks();
            if (includeMultipart) {
                var multipartTasks = multipartUploadAws.getUploadTasks();
                tasks = tasks.concat(multipartTasks);
            }
            return tasks;
        default:
            return [];
    }
}

function uploadAws(file, uploadOptions) {
    // 文件大于 10 mb 启用断点续传
    if (uploadOptions.supportsResumeUpload && file.size > 10 * 1024 * 1024) {
        return multipartUploadAws(file, uploadOptions);
    } else {
        return defaultUploadAws(file, uploadOptions);
    }
}


module.exports = {
    isInWhiteList: dataService.isInWhiteList,
    expandAccept: tool.expandAccept,
    uploadAws: uploadAws,
    uploadCos: uploadCos.upload,
    uploadByProvider: uploadByProvider,
    AwsPartialUploader: AwsPartialUploader,
    CosPartialUploader: CosPartialUploader,
    partialUploadByProvider: partialUploadByProvider,
    cancelUpload: cancelUpload,
    getUploadTasks: getUploadTasks,
};
